const eventFilterGroups = document.querySelectorAll('.c-filter-content');

if (eventFilterGroups.length > 0) {
  const eventLinks = document.querySelectorAll('.c-card.link.event');
  const CARDS_PER_PAGE = 6;

  // Track how many cards to show per section grid
  const paginationCounts = new Map();
  document.querySelectorAll('.c-grid.one-up.events').forEach(grid => {
    paginationCounts.set(grid, CARDS_PER_PAGE);
  });

  // Function to get all active filters
  const getActiveFilters = () => {
    const filters = {};

    eventFilterGroups.forEach(group => {
      const eventFilters = group.querySelectorAll('.c-filter input, .c-filter select');

      eventFilters.forEach(filter => {
        const filterType = filter.dataset.filterType || filter.name;
        if (!filterType) return;

        let filterValue = null;

        if (filter.type === 'checkbox') {
          if (filter.checked) {
            filterValue = filter.dataset.value ||
                         (filter.value !== 'on' ? filter.value : null) ||
                         filter.id ||
                         filter.name;
          }
        } else {
          filterValue = filter.value;
        }

        if (filterValue && filterValue !== 'all') {
          if (!filters[filterType]) {
            filters[filterType] = [];
          }
          filters[filterType].push(filterValue);
        }
      });
    });

    return filters;
  };

  // Apply pagination per section — run after filterEvents marks filteredOut
  const applyPagination = () => {
    document.querySelectorAll('.c-grid.one-up.events').forEach(grid => {
      const count = paginationCounts.get(grid) || CARDS_PER_PAGE;
      const cards = grid.querySelectorAll('.c-card.link.event');
      let shownCount = 0;

      cards.forEach(card => {
        if (card.dataset.filteredOut === 'true') {
          card.style.display = 'none';
          return;
        }
        shownCount++;
        card.style.display = shownCount <= count ? 'flex' : 'none';
      });

      const totalMatching = Array.from(cards).filter(c => c.dataset.filteredOut !== 'true').length;

      // Show/hide load more button
      const section = grid.closest('.c-events-wrap') || grid.parentElement;
      const loadMoreWrap = section?.querySelector('.c-load-more_wrap');
      if (loadMoreWrap) {
        loadMoreWrap.style.display = totalMatching > count ? '' : 'none';
      }

      // Show/hide empty message
      const emptyMsg = grid.nextElementSibling?.classList.contains('c-events-empty')
        ? grid.nextElementSibling
        : null;
      if (emptyMsg) {
        emptyMsg.style.display = totalMatching === 0 ? 'block' : 'none';
      }
    });
  };

  // Mark each card as filtered-out or not, then apply pagination
  const filterEvents = () => {
    const activeFilters = getActiveFilters();
    const dateRangeToggle = document.getElementById('date-range-toggle');
    const dateStart = dateRangeToggle?.checked ? document.getElementById('date-range-start')?.value : '';
    const dateEnd = dateRangeToggle?.checked ? document.getElementById('date-range-end')?.value : '';
    const hasActiveDateRange = !!(dateStart || dateEnd);
    const hasActiveFilters = Object.keys(activeFilters).length > 0 || hasActiveDateRange;

    // Reset pagination on every filter change
    document.querySelectorAll('.c-grid.one-up.events').forEach(grid => {
      paginationCounts.set(grid, CARDS_PER_PAGE);
    });

    eventLinks.forEach(link => {
      if (!hasActiveFilters) {
        link.dataset.filteredOut = 'false';
        return;
      }

      let shouldShow = true;

      for (const filterType of Object.keys(activeFilters)) {
        const filterValues = activeFilters[filterType];
        const linkValue = link.getAttribute('data-' + filterType);

        if (!linkValue) {
          shouldShow = false;
          break;
        }

        const hasMatch = filterValues.some(value => {
          const linkVal = linkValue.toLowerCase().trim();
          const filterVal = value.toLowerCase().trim();
          return linkVal === filterVal || linkVal.includes(filterVal);
        });

        if (!hasMatch) {
          shouldShow = false;
          break;
        }
      }

      // Check custom date range — overlap logic for multi-day events
      if (shouldShow && hasActiveDateRange) {
        const eventStart = (link.getAttribute('data-date') || '').split(' ')[0];
        const eventEnd = (link.getAttribute('data-date-end') || '').split(' ')[0] || eventStart;
        if (!eventStart) {
          shouldShow = false;
        } else {
          if (dateEnd && eventStart > dateEnd) shouldShow = false;
          if (dateStart && eventEnd < dateStart) shouldShow = false;
        }
      }

      link.dataset.filteredOut = shouldShow ? 'false' : 'true';
    });

    applyPagination();
  };

  // Load more button — expand visible count for that section
  document.querySelectorAll('.load-more').forEach(btn => {
    btn.addEventListener('click', () => {
      const grid = btn.closest('.c-events-wrap')?.querySelector('.c-grid.one-up.events');
      if (!grid) return;
      const current = paginationCounts.get(grid) || CARDS_PER_PAGE;
      paginationCounts.set(grid, current + CARDS_PER_PAGE);
      applyPagination();
    });
  });

  // Add event listeners to all filters
  eventFilterGroups.forEach(group => {
    const eventFilters = group.querySelectorAll('.c-filter input');
    eventFilters.forEach(filter => {
      filter.addEventListener('change', filterEvents);
    });
  });

  // All date filter checkboxes (Today, Tomorrow, This week, Custom date range)
  const dateCheckboxes = document.querySelectorAll('[data-filter-type="date"]');
  const dateRangeToggle = document.getElementById('date-range-toggle');
  const dateRangeInputs = document.querySelector('.c-date-range-inputs');
  const allDateInputs = [...dateCheckboxes, dateRangeToggle].filter(Boolean);

  const clearDateRange = () => {
    dateRangeInputs.style.display = 'none';
    document.getElementById('date-range-start').value = '';
    document.getElementById('date-range-end').value = '';
  };

  // Enforce mutual exclusion across all date filters
  allDateInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      allDateInputs.forEach(other => {
        if (other !== input && other.checked) {
          other.checked = false;
          other.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (input !== dateRangeToggle) clearDateRange();
    });
  });

  // Custom date range toggle — show/hide inputs and re-filter
  dateRangeToggle?.addEventListener('change', () => {
    if (dateRangeToggle.checked) {
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const toISO = d => d.toISOString().split('T')[0];
      document.getElementById('date-range-start').value = toISO(firstDay);
      document.getElementById('date-range-end').value = toISO(lastDay);
      dateRangeInputs.style.display = 'block';
    } else {
      clearDateRange();
    }
    filterEvents();
  });

  document.getElementById('date-range-start')?.addEventListener('change', filterEvents);
  document.getElementById('date-range-end')?.addEventListener('change', filterEvents);

  // Run on page load
  filterEvents();
}
